import { render, staticRenderFns } from "./Switching.vue?vue&type=template&id=1a973454"
import script from "./Switching.vue?vue&type=script&lang=js"
export * from "./Switching.vue?vue&type=script&lang=js"
import style0 from "./Switching.vue?vue&type=style&index=0&id=1a973454&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports